import React, { Component } from 'react';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';
import Join from './../../plan/join';
import { Trans } from "react-i18next";   
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

class Information extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: {
                items: [],api_url:localStorage.getItem('api_url'),activeItem: '',feed_image:'', feed_image_check:'',
                feed_location:'',feed_location_check:'',feed_job:'',feed_job_check:'',feed_bio:'',feed_bio_check:'',
                feed_company:'',feed_company_check:'',feed_school:'',feed_school_check:'',agestatus:'',agestatus_check:'',
                location:'',location_check:'',visible:'',visible_check:'',hideads:'',hideads_check:'',newmsg:'',newmsg_check:'',
                likes_check:'',successMessage:'',
            }
        };
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.toggleOption = this.toggleOption.bind(this);
        this.profilechange = this.profilechange.bind(this);
    }

    componentDidMount(){
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }

        const apiUrl = localStorage.getItem('api_url');
        var datalist = new FormData();   
        datalist.set('user_id',JSON.parse(localStorage.getItem('session_userid'))); 
        datalist.set('language', 'en'); 
          
        axios({
            method: 'post',
            url: apiUrl+'webprofile',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status === 'true') {
                const user_details = res.data.result;
                
                this.setState({
                    user_details: user_details,
                    agestatus: user_details.show_age,
                    location: user_details.show_location,
                    visible: user_details.invisible,
                    hideads: user_details.hide_ads,
                    newmsg: user_details.message_notification,
                    likes: user_details.like_notification,
                    activeItem: user_details.people_for,
                    feed_image: user_details.feed_image,
                    feed_location: user_details.feed_location,
                    feed_job: user_details.feed_job,
                    feed_bio: user_details.feed_bio,
                    feed_company: user_details.feed_company,
                    feed_school: user_details.feed_school, 
                    setlanguage: user_details.setlanguage,
                });
                localStorage.setItem('setlanguage',this.state.setlanguage);
                localStorage.setItem('language',this.state.setlanguage);
                if(this.state.agestatus === "true"){
                this.setState({
                    agestatus_check: "true",    
                });
                }
                if(this.state.location === "true"){
                    this.setState({
                        location_check: "true",    
                    });
                }
                if(this.state.visible === "true"){
                    this.setState({
                        visible_check: "true",    
                    });
                }
                if(this.state.hideads === "true"){
                    this.setState({
                        hideads_check: "true",    
                    });
                }
                if(this.state.newmsg === "true"){
                    this.setState({
                        newmsg_check: "true",    
                    });
                }
                if(this.state.likes === "true"){
                    this.setState({
                        likes_check: "true",    
                    });
                }
                if(this.state.feed_image === "true"){
                    this.setState({
                        feed_image_check: "true",    
                    });
                }
                if(this.state.feed_location === "true"){
                    this.setState({
                        feed_location_check: "true",    
                    });
                }
                if(this.state.feed_job === "true"){
                    this.setState({
                        feed_job_check: "true",    
                    });
                }
                if(this.state.feed_bio === "true"){
                    this.setState({
                        feed_bio_check: "true",    
                    });
                }
                if(this.state.feed_company === "true"){
                    this.setState({
                        feed_company_check: "true",    
                    });
                }
                if(this.state.feed_school === "true"){
                    this.setState({
                        feed_school_check: "true",      
                    });
                }
            } else {
                //this.props.history.push("/login");   
            }
        }).catch(error => {
           //this.props.history.push("/login"); 
        });

        axios.get(`${apiUrl}admindatas`)
        .then(res => {
            console.log("Data:", res.data);
            const items = res.data.result.peoplefor;
            this.setState({ items });
        })
        .catch(error => console.error("API call error:", error));
    }

    profilechange(){
        const apiUrl = localStorage.getItem('api_url');
        var profile = new FormData();
        profile.append('show_age', this.state.agestatus);
        profile.append('show_location', this.state.location);
        profile.append('invisible', this.state.visible);
        profile.append('hide_ads', this.state.hideads);
        profile.append('message_notification', this.state.newmsg);
        profile.append('like_notification', this.state.likes);
        
        profile.append('feed_image', this.state.feed_image);
        profile.append('feed_location', this.state.feed_location);
        profile.append('feed_bio', this.state.feed_bio);
        profile.append('feed_job', this.state.feed_job);
        profile.append('feed_company', this.state.feed_company);
        profile.append('feed_school', this.state.feed_school);  
        
        profile.append('people_for', this.state.activeItem);
        profile.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        profile.append('language', 'en');  

        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
       
        axios({
            method: 'post',
            url: apiUrl+'websetprofile',
            data: profile,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
                 })
        .then(res => {
            const message = res.data.message;
            this.setState({
                successMessage: message,
                suc_cls: 'successMsg floatingAlerts1'
            });
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
            }, 5000);    
            
        }).catch(error => {
            console.error('API call failed:', error.response ? error.response.data : error.message);
            // Update the UI to inform the user that the update failed
        });
                
   
    }

    handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        if (this.state.user_details.premium_member !== "true" && (id === 'agestatus' || id === 'location' || id === 'invisible' || id === 'hideads')) {
            this.setState({ premiummodal: true });
        }else{
            const target = e.target;
            const value = target.checked;
            const id = target.id;

            const stateMap = {
                agestatus: { valueKey: 'agestatus', checkKey: 'agestatus_check' },
                location: { valueKey: 'location', checkKey: 'location_check' },
                invisible: { valueKey: 'visible', checkKey: 'visible_check' },
                hideads: { valueKey: 'hideads', checkKey: 'hideads_check' },
                newmsg: { valueKey: 'newmsg', checkKey: 'newmsg_check' },
                likes: { valueKey: 'likes', checkKey: 'likes_check' },
                feed_image: { valueKey: 'feed_image', checkKey: 'feed_image_check' },
                feed_location: { valueKey: 'feed_location', checkKey: 'feed_location_check' },
                feed_job: { valueKey: 'feed_job', checkKey: 'feed_job_check' },
                feed_school: { valueKey: 'feed_school', checkKey: 'feed_school_check' },
                feed_bio: { valueKey: 'feed_bio', checkKey: 'feed_bio_check' },
                feed_company: { valueKey: 'feed_company', checkKey: 'feed_company_check' },
            };

            if (stateMap[id]) {
                this.setState({
                    [stateMap[id].valueKey]: value ? "true" : "false",
                    [stateMap[id].checkKey]: value
                });
            }
        }      
    };

    toggleOption = (id) => {
        const isActive = this.state.activeItem === id;
        this.setState({
            activeItem: isActive ? null : id
        });
    };

    toggleOption_old(id,e) {  
        this.setState({
            activeItem: id,
            peopleforid: e.target.alt,
            
        });
    }

    handlePremiumOpenModal = () => {
        this.setState({ premiummodal: true });
    }

    handlePremiumCloseModal = () => {
        this.setState({ premiummodal: false });
    }

    render() {
        const { user_details } = this.state;
        const isPremiumMember = user_details && user_details.premium_member === "true";
        return (
            <div className='whole_information'>
                <div className='whole_information'>
                    {this.state.successMessage && (
                        <div className={this.state.suc_cls}>
                            {this.state.successMessage}
                        </div>
                    )}
                </div>
                <div>
                    <div className='setting_subtab_title'>
                        <h4><Trans i18nKey="I am here to">I am here to</Trans></h4>
                    </div>
                    <div className='information_seeking'>
                        <div className='information_iam'>
                            {this.state.items && this.state.items.map((item, index) =>
                                <div className={`information_seeking_div ${this.state.activeItem === item.id ? 'seekingselect' : ''}`} 
                                onClick={() => this.toggleOption(item.id)} value={item.id}>
                                    <div className='information_seeking_subdiv'>
                                        <img value={item.id} src={item.icon} alt="img" />
                                        <img value={item.id} src={item.icon} alt="img" />
                                    </div>
                                    <h4>{item.name}</h4>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div>
                    <div className='setting_subtab_title subtab_titlediv'>
                        <h4><Trans i18nKey="Dedicated profile space">Dedicated profile space</Trans></h4>
                    </div>
                    <div className='information_formdiv'>
                        <Form.Group controlId="agestatus" className={`information_form ${this.state.agestatus_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="agestatus">
                                <span><Trans i18nKey="Don't share my age">Don't share my age</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="agestatus"
                                        value={this.state.agestatus}
                                        onChange={this.handleCheckboxChange}
                                        checked={isPremiumMember && this.state.agestatus_check}
                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>

                        </Form.Group>
                        <Form.Group controlId="location" className={`information_form ${this.state.location_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="location">
                                <span><Trans i18nKey="Sharing my location">Sharing my location</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="location"
                                        value={this.state.location}
                                        onChange={this.handleCheckboxChange}
                                        checked={isPremiumMember && this.state.location_check}
                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="invisible" className={`information_form ${this.state.visible_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="visible">
                                <span><Trans i18nKey="Make me invisible">Make me invisible</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="invisible"
                                        value={this.state.visible}
                                        onChange={this.handleCheckboxChange}
                                        checked={isPremiumMember && this.state.visible_check}
                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="hideads" className={`information_form ${this.state.hideads_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="hideads">
                                <span><Trans i18nKey="No ads">No ads</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="hideads"
                                        value={this.state.hideads}
                                        onChange={this.handleCheckboxChange}
                                        checked={isPremiumMember && this.state.hideads_check}
                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                    </div>
                </div>
                <div>
                    <div className='setting_subtab_title subtab_titledivs'>
                        <h4><Trans i18nKey="Notification settings ?">Notification settings ?</Trans></h4>
                    </div>
                    <div className='information_formdiv'>
                        <Form.Group controlId="newmsg" className={`information_form ${this.state.newmsg_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="newmsg">
                                <span><Trans i18nKey="New messages">New messages</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="newmsg"
                                        value={this.state.newmsg}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.newmsg_check}
                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>

                        </Form.Group>
                        <Form.Group controlId="likes" className={`information_form ${this.state.likes_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="likes">
                                <span><Trans i18nKey="Likes">Likes</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="likes"
                                        value={this.state.likes}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.likes_check}
                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                    </div>
                </div>
                <div>
                    <div className='setting_subtab_title subtab_titledivs'>
                        <h4><Trans i18nKey="Feeds settings ?">Feeds settings ?</Trans></h4>
                    </div>
                    <div className='information_formdiv'>
                        <Form.Group controlId="feed_image" className={`information_form ${this.state.feed_image_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="feed_image">
                                <span><Trans i18nKey="Feed image">Feed image</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="feed_image"
                                        value={this.state.feed_image}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.feed_image_check}

                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>

                        </Form.Group>
                        <Form.Group controlId="feed_location" className={`information_form ${this.state.feed_location_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="feed_location">
                                <span><Trans i18nKey="Feed location">Feed location</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="feed_location"
                                        value={this.state.feed_location} 
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.feed_location_check}

                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="feed_job" className={`information_form ${this.state.feed_job_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="feed_job">
                                <span><Trans i18nKey="Feed job">Feed job</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="feed_job"
                                        value={this.state.feed_job}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.feed_job_check}

                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="feed_school" className={`information_form ${this.state.feed_school_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="feed_school">
                                <span><Trans i18nKey="Feed school">Feed school</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="feed_school"
                                        value={this.state.feed_school}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.feed_school_check}

                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="feed_bio" className={`information_form ${this.state.feed_bio_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="feed_bio">
                                <span><Trans i18nKey="Feed bio">Feed bio</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="feed_bio"
                                        value={this.state.feed_bio}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.feed_bio_check}

                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="feed_company" className={`information_form ${this.state.feed_company_check ? 'information_checked' : ''}`}>
                            <Form.Check.Label htmlFor="feed_company">
                                <span><Trans i18nKey="Feed company">Feed company</Trans></span>
                            </Form.Check.Label>
                            <div className='information_position'>
                                <div className='form-switch'>
                                    <Form.Check.Input
                                        type="checkbox"
                                        id="feed_company"
                                        value={this.state.feed_company}
                                        onChange={this.handleCheckboxChange}
                                        checked={this.state.feed_company_check}

                                    />
                                    <span class="toggle round"></span>
                                </div>
                            </div>
                        </Form.Group>
                        <div className='deactivate_button'>
                            <Button onClick={this.profilechange}><Trans i18nKey="Save">Save</Trans></Button>
                        </div>
                    </div>
                </div>
                <Join
                    showModal={this.state.premiummodal}
                    handleClose={this.handlePremiumCloseModal}
                />
            </div>
        );
    }
}

export default withTranslation("translations")(Information);
